import React from "react";
import { NavLink } from "react-router-dom";

const GoDetail = (props) => {
  return (
    <button className="btn btn-more">
      <NavLink to={props.to}>
        {props.page} 페이지로 가기
      </NavLink>
    </button>
  );
};

export default GoDetail;
